export class EventArgs<T> {
    constructor(public readonly event: Slick.EventData | DOMEvent, public readonly data: T) {
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/event-args.ts